module.exports = __webpack_public_path__ + "static/media/51.98ec6dfb.gif";